<template>
  <div class="container">
    <div class="card">
      <div class="card-body">
        <p class="card-text">Welcome to the Taxi1 admin portal</p>
      </div>
    </div>
  </div>
</template>

<style scoped>
.container {
  min-height: 100vh;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 15vh;
}

.card {
  width: 100%;
}

.card-text {
  font-family: 'Euclid Square';
  font-style: normal;
  font-weight: 400;
  font-size: 36px;
  line-height: 46px;
  text-align: center;
  color: #051C2C;
}
</style>